import styled from 'styled-components';

export const StyledMessage = styled.h4`
  font-weight: 400;
  color: #b1b3bc;
  padding-top: 1rem;
`;
